<template>
  <div ref="container">
    <slot />
  </div>
</template>

<script>

export default {
  data() {
    return {
      index: 0,
      tabs: [],
    }
  },
  computed: {
    isLast() {
      return this.index == this.tabs.length - 1
    }
  },
  mounted() {
    this.tabs = this.$children.filter(c => c.$options.name == 'WizardPage')
    this.tabs[0].active =  true
  },
  watch: {
    index(i) {
      this.$emit('changepage', i)
    }
  },
  methods: {
    isComplete() {
      return this.tabs[this.index].isComplete()
    },
    touchForErrors() {
      this.tabs[this.index].touchForErrors()
    },
    prev() {
      const nextIndex = Math.max(0, this.index - 1)
      this.tabs[this.index].active = false
      this.index = nextIndex
      this.tabs[this.index].active = true
    },
    next() {
      if(!this.tabs[this.index].isComplete()) {
        this.tabs[this.index].touchForErrors()
        return false;
      }

      const nextIndex = this.index + 1
      if(this.tabs.length > nextIndex) {
        this.tabs[this.index].active = false
        this.index = nextIndex
        this.tabs[this.index].active = true
      }

      this.$root.$emit('scroll-top', 0)
      //window.scrollTo(0,0)
      //this.$refs.container.scrollIntoView()
    }
  }

}
</script>

<style>

</style>